import React, { useEffect } from "react";

function SessionJoiner({ onJoin, isLoading }) {
  // Extract session ID from URL
  useEffect(() => {
    // Get the session ID from the URL parameter
    const urlParams = new URLSearchParams(window.location.search);
    const sessionId = urlParams.get('session');
    
    // If session ID exists in URL, automatically join that session
    if (sessionId) {
      onJoin(sessionId);
    } else {
      console.warn("No session ID found in URL. Please scan the QR code from the salon's iPad.");
    }
  }, [onJoin]);

  return (
    <div className="join-container">
      <div className="join-card">
        <h1 className="join-title">SessionTunes</h1>
        <p className="join-subtitle">Welcome to the Salon Music Experience</p>
        
        {isLoading ? (
          <div className="loading-state">
            <div className="loading-spinner"></div>
            <p>Connecting to session...</p>
          </div>
        ) : (
          <div className="error-state">
            <svg width="64" height="64" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ opacity: 0.7, margin: '0 auto 1rem', display: 'block' }}>
              <circle cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="2"/>
              <path d="M12 8V12" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
              <circle cx="12" cy="16" r="1" fill="currentColor"/>
            </svg>
            <p style={{ fontWeight: '500', fontSize: '1.1rem' }}>No Session Found</p>
            <p style={{ marginTop: '0.5rem', color: 'var(--text-secondary)' }}>Please scan the QR code from the salon's iPad to join a music session.</p>
          </div>
        )}
        
        {/* Info section */}
        <div style={{ 
          marginTop: '2rem',
          padding: '1rem',
          backgroundColor: 'rgba(0, 0, 0, 0.05)',
          borderRadius: 'var(--radius-md)',
          fontSize: '0.9rem',
          color: 'var(--text-secondary)'
        }}>
          <p style={{ margin: '0 0 0.5rem' }}><strong>How It Works:</strong></p>
          <ol style={{ margin: 0, paddingLeft: '1.5rem' }}>
            <li>Scan the QR code on the salon's iPad</li>
            <li>Search for your favorite songs on Apple Music</li>
            <li>Add them to the shared playlist</li>
            <li>Music plays automatically through the salon's speakers</li>
          </ol>
        </div>
      </div>
      
      {/* Animation elements */}
      <div className="background-animation"></div>
      
      {/* Styling for background animations */}
      <style jsx>{`
        .background-animation {
          position: absolute;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          overflow: hidden;
          z-index: -1;
        }
        
        .background-animation:before,
        .background-animation:after {
          content: '';
          position: absolute;
          width: 300px;
          height: 300px;
          border-radius: 50%;
          opacity: 0.2;
          filter: blur(60px);
        }
        
        .background-animation:before {
          background-color: var(--primary);
          top: -100px;
          right: -50px;
          animation: float 10s infinite alternate;
        }
        
        .background-animation:after {
          background-color: var(--secondary);
          bottom: -100px;
          left: -50px;
          animation: float 13s infinite alternate-reverse;
        }
        
        @keyframes float {
          0% { transform: translate(0, 0) scale(1); }
          50% { transform: translate(40px, 20px) scale(1.1); }
          100% { transform: translate(-40px, 40px) scale(0.9); }
        }
      `}</style>
    </div>
  );
}

export default SessionJoiner;